"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var lib_i18n_1 = require("@doordash/lib-i18n");
var lodash_1 = require("lodash");
var enums_1 = require("../Common/utils/enums");
var en_us = __importStar(require("./translations/en-US.json"));
var es = __importStar(require("./translations/es.json"));
var fr_ca = __importStar(require("./translations/fr-CA.json"));
exports.SUPPORTED_LANGUAGES = {
    en: {
        code: lib_i18n_1.SupportedLanguages.EN,
        name: 'English'
    },
    fr: {
        code: lib_i18n_1.SupportedLanguages.FR,
        name: 'Français'
    },
    es: {
        code: lib_i18n_1.SupportedLanguages.ES,
        name: 'Español'
    }
};
var i18n = lib_i18n_1.createI18nInstance({
    englishStrings: en_us,
    frenchStrings: fr_ca,
    spanishStrings: es
});
exports.DEFAULT_LANGUAGE_CODE = exports.SUPPORTED_LANGUAGES.en.code;
exports.updateLangAttribute = function (language) {
    if (document && document.documentElement) {
        document.documentElement.lang = language;
    }
};
function getStringsForExperience(doorDashStrings, experience) {
    if (experience === enums_1.Experience.Caviar) {
        return lodash_1.merge(doorDashStrings, doorDashStrings.caviar);
    }
    return doorDashStrings;
}
exports.getStringsForExperience = getStringsForExperience;
exports["default"] = {
    t: function (key, options) { return i18n.t(key, options); },
    changeLanguage: function (value) {
        i18n.changeLanguage(value);
        exports.updateLangAttribute(value);
    }
};
